<script setup>
import {ref, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import axios from "axios";
import {priceFormat} from '@/use/price-format'
//----------------------------------------------------------------------
const store = useStore()
const certificate = ref([])

// дополнительные уведомления
const list1 = ref([])
const inList1 = ref(false)
const list2 = ref(['00238','00345'])
const inList2 = ref(false)
onMounted( ()=>{
  init()
})

const init = async () => {
  store.commit('menuModule/initMenu')
  let url = process.env.VUE_APP_API + 'certificate.php'
  let urlInfo = process.env.VUE_APP_API + 'info.php'
  await axios
      .get(`${url}?token=${token.value}&section=${user.value.type}&id=${user.value.id}`)
      .then(response => (certificate.value = response.data))
      .then(
          await axios
              .get(urlInfo)
              .then(response => (list1.value = response.data))
      )
      .catch(error => alert(error));
      // найти номер в массиве list1
      inList1.value = list1.value.includes(user.value.id)
      inList2.value = list2.value.includes(user.value.id)

}
//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})
</script>

<template>
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h5>Свидетельство о возможности предоставления жилищного займа
              <br>по целевой программе Санкт-Петербурга «Доступное жилье» № З-{{ user.id }}</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">

        <div class="row" v-if="inList1">
          <div class="col-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header">
                <strong>
                  Ваше свидетельство о возможности предоставления жилищного займа по программе «Доступное жилье» продлено на три месяца от срока окончания, указанного в свидетельстве.
                </strong>
              </div>
              <div class="card-body">
              <p>Ждем Вас с документами на согласование параметров сделки, начиная с 15.11.2023 г.</p>
              <p>Получить свидетельство с продленным сроком можно в Ипотечном центре АО «СПб ЦДЖ» по адресу:
                <br>СПб, ул.Серпуховская, д.2/68, пн-чт 09-00 – 18-00, пт 09-00 – 17-00.</p>
              <p><strong>Следите за нашими новостями!</strong></p>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="inList2">
          <div class="col-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header">
                <strong>
                  Ваше свидетельство о возможности предоставления жилищного займа по программе «Доступное жилье» продлено до наступления 36-летия.
                </strong>
              </div>
              <div class="card-body">
                <p>Ждем Вас с документами на согласование параметров сделки, начиная с 15.11.2023 г.</p>
                <p>Получить свидетельство с продленным сроком можно в Ипотечном центре АО «СПб ЦДЖ» по адресу:
                  <br>СПб, ул.Серпуховская, д.2/68, пн-чт 09-00 – 18-00, пт 09-00 – 17-00.</p>
                <p><strong>Следите за нашими новостями!</strong></p>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="certificate[0] && !certificate[0].validDate">
          <div class="col-12 mb-4">
            <div class="callout callout-danger p-4">
              <h5>Данные по свидетельству ещё не загружены в личный кабинет</h5>
              <p>По техническим причинам обновление данных о выданных свидетельствах происходит два раза в сутки.
                <br>Если Вы зарегистрировались в период с 10:00 до 18:00, то актуальная информация появится в личном кабинете после 18:00.
                <br>По всем вопросам Вы также можете обратиться в ЦЕНТР ДОСТУПНОГО ЖИЛЬЯ по тел. (812) 640 57 22.</p>
            </div>
          </div>
        </div>

        <div class="row" v-if="certificate[0] && certificate[0].validDate">

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header text-center">
                <v-icon
                    class="certificate-icon"
                    icon="mdi:calendar-check-outline"
                ></v-icon>
                <br>Срок действия</div>
              <div class="card-body text-center"><h5>{{ certificate[0].validDate }}</h5></div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header text-center">
                <v-icon
                    class="certificate-icon"
                    icon="mdi:alert-circle-outline"
                ></v-icon>
                <br>Статус свидетельства</div>
              <div class="card-body text-center"><h5>{{ certificate[0].statusDescription }}</h5></div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header text-center">
                <v-icon
                    class="certificate-icon"
                    icon="mdi:account-circle-outline"
                ></v-icon>
                <br>Получателей содействия</div>
              <div class="card-body text-center"><h5>{{ certificate[0].participants }}</h5></div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header text-center">
                <v-icon
                    class="certificate-icon"
                    icon="mdi:currency-rub"
                ></v-icon>
                <br>Максимальная сумма займа</div>
              <div class="card-body text-center"><h5>{{ priceFormat(certificate[0].summMax) }}</h5></div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header text-center">
                <v-icon
                    class="certificate-icon"
                    icon="mdi:currency-rub"
                ></v-icon>
                <br>Фактическая сумма займа</div>
              <div class="card-body text-center"><h5>{{ priceFormat(certificate[0].summFact) }}</h5></div>
            </div>
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <div class="card card-outline card-info">
              <div class="card-header text-center">
                <v-icon
                    class="certificate-icon"
                    icon="mdi:clipboard-text-clock-outline"
                ></v-icon>
                <br>Данные обновлены</div>
              <div class="card-body text-center"><h5>{{ user['updateDate'] }}</h5></div>
            </div>
          </div>
        </div>

        <h5>Дополнительные услуги</h5>

        <div class="row mt-4">

          <div class="col-xl-3 col-md-6 col-sm-12">
            <div class="card card-outline card-orange">
              <a class="black-link" href="https://gorcenter.spb.ru/ocenochnie-kompanii" target="_blank">
                <div class="card-body text-center">
                  <v-icon
                      class="service-icon--orange mb-3"
                      icon="mdi:chart-bar"
                  ></v-icon>
                  <h6>Заказать отчет<br>об оценке</h6>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xl-3 col-md-6 col-sm-12">
            <div class="card card-outline card-success">
              <a class="black-link" href="https://gorcenter.spb.ru/e-registracia" target="_blank">
                <div class="card-body text-center">
                  <v-icon
                      class="service-icon--success mb-3"
                      icon="mdi:checkbox-multiple-marked"
                  ></v-icon>
                  <h6>Электронная<br>регистрация</h6>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xl-3 col-md-6 col-sm-12">
            <div class="card card-outline card-primary">
              <a class="black-link" href="https://gorcenter.spb.ru/novostroiki" target="_blank">
                <div class="card-body text-center">
                  <v-icon
                      class="service-icon mb-3"
                      icon="mdi:domain"
                  ></v-icon>
                  <h6>Аккредитованные<br>объекты</h6>
                </div>
              </a>
            </div>
          </div>

          <div class="col-xl-3 col-md-6 col-sm-12">
            <div class="card card-outline card-danger">
              <a class="black-link" href="https://gorcenter.spb.ru/programmy/vnesenie-izmenenij" target="_blank">
                <div class="card-body text-center">
                  <v-icon
                      class="service-icon--danger mb-3"
                      icon="mdi:note-remove"
                  ></v-icon>
                  <h6>Написать<br>отказ</h6>
                </div>
              </a>
            </div>
          </div>
        </div>
        <br>

      </div>
    </section>
</template>
<style scoped>
  .service-icon{
    width:40px;
    height:40px;
    color: #198bfe;
  }
  .service-icon--orange{
    width:40px;
    height:40px;
    color: #ff851b;
  }
  .service-icon--success{
    width:40px;
    height:40px;
    color: #28a745;
  }
  .service-icon--danger{
    width:40px;
    height:40px;
    color: #dc3545;
  }
  .certificate-icon{
    width:40px;
    height:40px;
    color: #17a2b8;
    margin:0 0 10px 0;
  }
  .certificate-data{}
  @media only screen and (max-width : 760px) {
    .certificate-data{text-align: right}
  }
</style>